import { lazy } from 'react'
import InvoicesLoader from './invoices/loader'
import EditInvoiceLoader from './invoices/edit/loader'

export default {
  Invoices: {
    Component: lazy(() => import('./invoices/Invoices.Page')),
    Loader: InvoicesLoader,
  },
  InvoiceHistory: {
    Component: lazy(() => import('./invoices/history/InvoiceHistory.Page')),
    Loader: InvoicesLoader,
  },
  EditInvoice: {
    Component: lazy(() => import('./invoices/edit/EditInvoice.Page')),
    Loader: EditInvoiceLoader,
  },
}
